import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';

class NameFormatter extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired
  };

  render() {
    return (<FormattedMessage
        id="user.name"
        defaultMessage="{firstName} {lastName}"
        values={{
        firstName: this.props.user.first_name,
        lastName: this.props.user.last_name
        }}
    />);
  }
}

export default NameFormatter;



// WEBPACK FOOTER //
// ./src/components/NameFormatter.jsx